import apiRequest from 'client/helpers/apiRequest';
import { OutreachEntity, Event, OutreachEntityType } from '@interfaces/outreach-entity';
import ListResponse from '@interfaces/list-response';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { YearsFilter } from '@interfaces/years-filter';

export type OutreachResponseList<T> = ListResponse<OutreachEntity<T>>;
export type EventList = OutreachResponseList<Event>;

export function fetchEventsPage(requestParams: OutreachRequestParams = {}): Promise<EventList> {
    const { page: pageNumber = 1, pageSize = 5, year } = requestParams;

    const params: any = { pageNumber, pageSize };
    if (year) {
        params.year = year;
    }

    return apiRequest.get<EventList>(`/api/outreach/${OutreachEntityType.event}`, { params });
}

export function fetchEventsFilters(): Promise<YearsFilter> {
    return apiRequest.get<YearsFilter>(`/api/outreach/${OutreachEntityType.event}/filters`);
}
